<template>
	<div class="faq">
		<h2 class="faq-title">{{ doc.faq.title }}</h2>
		<div class="faq-block">

			<div class="faq-list" v-for="(num,i) in 4" :key="i">
				<div class="bl-title">
					<span>{{num}}</span>
					<font>
						{{ doc.faq['t'+num] }}
					</font>
				</div>
				<div class="bl-content">
					<div class="bl-text">
						<div class="triangle-left"></div>

						<div class="answ">
							<div class="answ-wrap" v-html="doc.faq['c'+num]"></div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="faq-memo" v-html="doc.faq.memo"></div>
	</div>
</template>
<script>
export default {
	props: {
		doc: {
			type: Object,
		},
	},
};
</script>
<style lang="scss" rel="stylesheet/scss" >
// vw + rem
// 根元素大小使用 vw 单位
$vw_design: 720;
// rem 单位换算：定为 75px 只是方便运算，750px-75px、640-64px、1080px-108px，如此类推
$vw_fontsize: 72; // iPhone 6尺寸的根元素大小基准值

@function rem($px) {
	@return ($px / $vw_fontsize) * 1rem;
}

a {
	color: #fff;
}
.faq {
	margin-bottom: rem(-2);
	width: 100%;
	background: #282828;
	text-align: center;
	padding-bottom: rem(76);
	.faq-title {
		margin: 0 auto rem(61);
		text-align: center;
		padding-top: rem(72);
		font-size: rem(52);
		font-weight: bold;
		color: #faff35;
		line-height: rem(61);
		width: rem(509);
	}
	.faq-block {
		width: rem(656);
		margin: 0 auto;
		.faq-list {
			margin-bottom: rem(26);
			margin: auto;
			.bl-title {
				width: 100%;
				margin: 0 auto;
				text-align: left;
				display: flex;
				align-items: flex-start;
				font-size: rem(28);
				line-height: 1.2;
				color: #fff;
				letter-spacing: 0;
				span:nth-child(1) {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					background: #333333;
					height: rem(28);
					width: rem(28);
					border-radius: 50%;
					font-size: rem(19);
					color: #fff;
					letter-spacing: 0;
					margin-right: rem(8);
				}
				h2 {
					width: rem(1026);
					margin: 0 auto;
					text-align: left;
					display: flex;
					align-items: center;
					font-size: rem(24);
					line-height: rem(24);
					color: #333;
					letter-spacing: 0;
				}
			}
			.bl-content {
				margin: 0 auto;
				margin-top: rem(12);
				margin-bottom: rem(60);
				display: flex;
				align-items: center;
				justify-content: center;
				.bl-text {
					width: rem(637);
					padding: rem(24) rem(14);
					font-size: rem(14);
					color: #9a9a9a;
					letter-spacing: 0;
					line-height: rem(18);
					text-align: left;
					background: #333333;
					border-radius: rem(8);

					.triangle-left {
						width: 0;
						height: 0;
						position: relative;
						left: rem(-34);
						z-index: 1;
						margin-bottom: rem(-50);
						top: rem(-24);
						border: rem(24) solid transparent;
						border-top: rem(24) solid #333333;
						border-radius: rem(16);
					}
					.answ {
						font-size: rem(24);
						line-height: rem(28);
						border-radius: rem(20);
						border-top-left-radius: 0;
						margin-left: rem(10);
						position: relative;
					}
				}
			}
		}
		.answ-wrap {
			color: #fff;
			font-size: rem(24);
			line-height: 1.35;
			b {
				font-weight: bold;
			}
		}
	}
	.small-more-btn {
		a {
			color: #fff;
			font-size: rem(18);
			font-family: Roboto-Bold;
			font-weight: bold;
			color: #fafafa;
		}
	}
}
.faq-memo {
	font-size: rem(18);
	font-family: Roboto-Bold, Roboto;
	font-weight: bold;
	color: #757575;
	line-height: rem(19);
	width: rem(570);
	margin: rem(99) auto 0;
}
</style>
